import React from 'react'
import MovimentationGraph from '../movimentations/MovimentationGraph'
// import { Chart, Pies, Transform } from 'rumble-charts';
import './operation-cicle.css'

const OperationCicle = props => {
    const data = [
        { value: 0, color: '#d4d3f5' },
        { value: props.data.value, color: '#A4A1FC' }
    ]
    return (
        <div className="operation-cicle">

            <div className='operation-cicle-header'>
                <span>Ciclo da Operação</span>
            </div>
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '90%',
                // backgroundColor: 'red',
                // paddingTop: '20px'
            }}>
                <div className='operation-cicle-graph'>
                    <MovimentationGraph data={data} total={props.data.label} unique={true}/>
                </div>

            </div>



        </div>
    )
}

export default OperationCicle